import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Location as _Location} from '@angular/common';

@Component({
  selector: 'app-abandon-form',
  templateUrl: './abandon-form.component.html',
  styleUrls: ['./abandon-form.component.scss']
})
export class AbandonFormComponent implements OnInit {

  constructor(
    private activeModal: NgbActiveModal,
    private _location: _Location) {
  }

  ngOnInit(): void {
  }

  public goBack() {
    this._location.back();
  }

  keepEditing() {
    this.activeModal.close(false);
  }

  abandonChanges() {
    this.activeModal.close(true);
  }


}
